import { colors } from '../colors';
const DEFAULT_THEME = {
  primary: colors.primaryDeep,
  primaryHover: colors.primaryBright,
  primaryPressed: colors.primaryDeeper,
  textOnPrimary: colors.white,
  secondary: colors.black,
  secondaryHover: colors.neutralDeepest,
  secondaryPressed: colors.black,
  textOnSecondary: colors.white,
  inverted: colors.white,
  invertedHover: colors.neutralBrightest,
  invertedPressed: colors.white,
  textOnInverted: colors.black
};
const PARTNER_THEME = {
  primary: colors.black,
  primaryHover: colors.neutralDeepest,
  primaryPressed: colors.black,
  textOnPrimary: colors.white,
  secondary: colors.black,
  secondaryHover: colors.neutralDeepest,
  secondaryPressed: colors.black,
  textOnSecondary: colors.white,
  inverted: colors.white,
  invertedHover: colors.neutralBrightest,
  invertedPressed: colors.white,
  textOnInverted: colors.black
};
export { DEFAULT_THEME, PARTNER_THEME };